import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { CalendarClock, Repeat } from "lucide-react";
import { errMsg } from "@/lib/api";
import { fmtBR } from "./broadcasts/SchedulePanel";

const DAY = 24 * 3600 * 1000;

export const UpcomingSends = () => {
  const { api } = useOutletContext();
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/scheduled").then((r) => {
    const limit = Date.now() + DAY;
    setItems(r.data.filter((s) => s.status === "agendado" && new Date(s.run_at).getTime() <= limit));
  }).catch(() => setItems([]));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const cancel = async (s) => {
    if (!window.confirm(`Cancelar o envio para “${s.group_name}” em ${fmtBR(s.run_at)}?`)) return;
    try { await api.delete(`/admin/scheduled/${s.id}`); toast.success("Envio cancelado."); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (items === null) return null;
  return (
    <section data-testid="home-upcoming" className="space-y-2 px-5 pt-6 md:px-8">
      <h2 className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
        <CalendarClock className="h-4 w-4" />Envios das próximas 24 horas
      </h2>
      {items.length === 0 ? (
        <p data-testid="home-upcoming-empty" className="max-w-6xl rounded-lg border border-dashed border-zap-line p-4 text-sm text-muted-foreground">Nenhum envio agendado para as próximas 24 horas.</p>
      ) : (
        <ul className="max-w-6xl divide-y divide-zap-line rounded-lg border border-zap-gold/50 bg-white">
          {items.map((s) => (
            <li key={s.id} data-testid={`home-upcoming-${s.id}`} className="flex flex-wrap items-center gap-3 px-4 py-3">
              <div className="min-w-0 basis-full sm:basis-0 sm:flex-1">
                <p className="flex flex-wrap items-center gap-2 font-semibold">
                  <span className="capitalize">{fmtBR(s.run_at)}</span><span className="text-zap-deep">→ {s.group_name}</span>
                  {s.repeat_weekly && <span className="flex items-center gap-1 text-xs font-medium text-zap-deep"><Repeat className="h-3.5 w-3.5" />toda semana</span>}
                </p>
                <p className="line-clamp-2 text-sm text-muted-foreground">
                  {[s.text, s.audio_title && `Áudio: ${s.audio_title}`, s.video_title && `Vídeo: ${s.video_title}`, s.youtube_url && "YouTube", s.link_url && `Link: ${s.link_url}`].filter(Boolean).join(" + ")}
                </p>
              </div>
              <Link to={`/admin/transmissoes?g=${s.group_id}`} data-testid={`home-upcoming-review-${s.id}`} className="rounded-md border border-zap-deep px-3 py-1.5 text-sm font-semibold text-zap-deep hover:bg-zap-mist">Revisar</Link>
              <button type="button" data-testid={`home-upcoming-cancel-${s.id}`} onClick={() => cancel(s)} className="rounded-md px-3 py-1.5 text-sm font-semibold text-red-700 hover:bg-red-50">Cancelar</button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
